var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-app-header-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('WsIcon',[_vm._v("language")]),_c('div',{staticClass:"ws-app-header-button__text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }